"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleAngularComponent = void 0;
const core_1 = require("@angular/core");
const i0 = __importStar(require("@angular/core"));
class SimpleAngularComponent {
    constructor() {
        this.outputparameter = new core_1.EventEmitter(false);
        console.log('Simple Angular component loaded');
    }
    onClick() {
        console.log('event emitted in Angular');
        this.outputparameter.emit(true);
    }
}
exports.SimpleAngularComponent = SimpleAngularComponent;
SimpleAngularComponent.ɵfac = function SimpleAngularComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SimpleAngularComponent)(); };
SimpleAngularComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SimpleAngularComponent, selectors: [["simple-angular"]], inputs: { inputparameter: "inputparameter" }, outputs: { outputparameter: "outputparameter" }, decls: 7, vars: 1, consts: [[1, "boxContent"], ["id", "exampleDowngrade", "type", "button", 1, "main_btn", 3, "click"], [1, "fas", "fa-plus"]], template: function SimpleAngularComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "h3");
        i0.ɵɵtext(2, "Angular component");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div");
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "button", 1);
        i0.ɵɵlistener("click", function SimpleAngularComponent_Template_button_click_5_listener() { return ctx.onClick(); });
        i0.ɵɵelement(6, "i", 2);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1("input param: ", ctx.inputparameter, "");
    } }, encapsulation: 2 });
